import { enterpriseApiSlice } from "./index";

export const stripeChargesApi = enterpriseApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchCharges: builder.query({
      query: () => ({
        url: "/stripe/charges",
        method: "GET",
      }),
      extraOptions: { auth: true },
      providesTags: ["Charges"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useFetchChargesQuery,
} = stripeChargesApi;

